export default __webpack_public_path__ + "static/media/LogoTablePreview.7f0ef7c8.jpg";